// extracted by mini-css-extract-plugin
export default {"popoverWrapper":"Popover_popoverWrapper__M6hBL","popoverContent":"Popover_popoverContent__fbMjB"};